import React, { Fragment, useEffect, useState } from 'react';
type CountdownProps = {
  className?: string;
};
export function Countdown({
  className = ''
}: CountdownProps) {
  const [seconds, setSeconds] = useState(83027);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units: Array<[string, number]> = [['ore', Math.floor(seconds / 3600)], ['minuti', Math.floor(seconds % 3600 / 60)], ['secondi', seconds % 60]];
  return <div className={`inline-flex items-center gap-2 ${className}`} aria-label="Tempo rimanente per questa offerta" data-id="element-201" data-mp="1jhk78ffedwd1">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-202" data-mp="1teol7rz3alir" data-mpi={index}>
          {index > 0 && <span className="text-2xl font-black text-primary" data-id="element-203" data-mp="1tcvekcoh81ar">:</span>}
          <span className="flex min-w-[76px] flex-col items-center rounded-xl bg-accent px-3 py-2.5 leading-none shadow-md shadow-black/40" data-id="element-204" data-mp="38ufej5t0x256">
            <b className="text-3xl font-bold tabular-nums tracking-tight text-accent-foreground" data-id="element-205" data-mp="34tbzglisva50">
              {String(value).padStart(2, '0')}
            </b>
            <small className="mt-1 text-[10px] font-bold uppercase tracking-wider text-accent-foreground" data-id="element-206" data-mp="2h5ysqkc90jip">{label}</small>
          </span>
        </Fragment>)}
    </div>;
}